import { Facebook, Linkedin, Instagram, Share2 } from 'lucide-react';
import WhatsAppIcon from '@/components/WhatsAppIcon';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const shareUrl = 'https://www.rlxhk.com';
  const shareText = 'RLX — Digital Agency in Hong Kong specializing in web, apps and brand identity';

  const socialLinks = [
    {
      label: 'Share RLX on Facebook',
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      Icon: Facebook,
    },
    {
      label: 'Share RLX on LinkedIn',
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
      Icon: Linkedin,
    },
    {
      label: 'Share RLX on WhatsApp',
      href: `https://wa.me/?text=${encodeURIComponent(`${shareText} ${shareUrl}`)}`,
      Icon: WhatsAppIcon,
    },
    {
      label: 'Visit RLX on Instagram',
      href: 'https://www.instagram.com/',
      Icon: Instagram,
    },
  ];

  return (
    <footer className="bg-foreground text-background py-16">
      <div className="container-padding max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-2">
            <img
              alt="RLX Digital Agency Hong Kong logo"
              className="h-10 w-auto mb-6"
              src="/lovable-uploads/78046cdf-65a9-4bf9-ab5d-edeb0284a87f.png"
              width="160"
              height="40"
            />
            <p className="text-background/70 max-w-md mb-6">
              RLX is a Hong Kong-based digital agency specializing in website development,
              mobile apps, graphic design, and brand identity solutions.
            </p>
            <div>
              <p className="flex items-center gap-2 text-sm font-semibold text-background/80 mb-3">
                <Share2 className="w-4 h-4" aria-hidden="true" focusable="false" /> Share this page
              </p>
              <div className="flex items-center gap-3">
                {socialLinks.map(({ label, href, Icon }) => (
                  <a
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    className="w-10 h-10 rounded-lg border border-background/20 flex items-center justify-center hover:border-primary hover:text-primary transition-colors"
                  >
                    <Icon className="w-4 h-4" aria-hidden="true" focusable="false" />
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-background mb-4">Services</h4>
            <ul className="space-y-3 text-background/70">
              <li><a href="#services" className="hover:text-primary transition-colors">Custom Website Development</a></li>
              <li><a href="/websites" className="hover:text-primary transition-colors">Zero Deposit Websites for SMEs</a></li>
              <li><a href="#services" className="hover:text-primary transition-colors">iOS & Android Mobile Apps</a></li>
              <li><a href="#services" className="hover:text-primary transition-colors">UI/UX & Graphic Design Services</a></li>
              <li><a href="#services" className="hover:text-primary transition-colors">Logo Design & Brand Identity</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-background mb-4">Quick Links</h4>
            <ul className="space-y-3 text-background/70">
              <li><a href="#about" className="hover:text-primary transition-colors">About Our Studio</a></li>
              <li><a href="#portfolio" className="hover:text-primary transition-colors">View Portfolio</a></li>
              <li><a href="#contact" className="hover:text-primary transition-colors">Contact the Team</a></li>
              <li><a href="/get-started" className="hover:text-primary transition-colors">Get a Free Demo</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-background/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-background/50 text-sm">
            © {currentYear} RLX. All rights reserved.
          </p>
          <p className="text-background/50 text-sm">
            Digital Agency in Tsim Sha Tsui East, Hong Kong
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
